module.exports = __webpack_public_path__ + "static/media/image4.da95f35e.png";